const storageKey = (boundaryId) => `yona:map-print:logo:${boundaryId}`;

export function loadLogoChoice(boundaryId) {
  if (!boundaryId || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(storageKey(boundaryId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      url: typeof parsed.url === 'string' ? parsed.url : '',
      position: parsed.position === 'right' ? 'right' : 'left',
    };
  } catch (_err) {
    return null;
  }
}

export function saveLogoChoice(boundaryId, { url, position }) {
  if (!boundaryId || typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(
      storageKey(boundaryId),
      JSON.stringify({
        url: url || '',
        position: position === 'right' ? 'right' : 'left',
      })
    );
  } catch (_err) {
    // Quota or private mode — the sheet still renders for this session.
  }
}
